import React from "react";
import EmptyCpsNotice from "./notices/EmptyCpsNotice";
import GranteeExemptionNotice from "./notices/GranteeExemptionNotice";
import HinNotice from "./notices/HinNotice";
import InHousePharmacyNotice from "./notices/InHousePharmacyNotice";
import NoCpsInRangeNotice from "./notices/NoCpsInRangeNotice";
import WhollyOwnedExemptionNotice from "./notices/WhollyOwnedExemptionNotice";

export default function DesignationNotices(props) {
  return (
    <>
      <WhollyOwnedExemptionNotice
        disableWhollyOwnedNotice={props.disableWhollyOwnedNotice}
        hasWoDesignation={props.hasWoDesignation}
        policy_doc_url={props.policy_doc_url}
      />
      <GranteeExemptionNotice
        disableGranteeNotice={props.disableGranteeNotice}
        isGrantee={props.isGrantee}
        policy_doc_url={props.policy_doc_url}
      />
      <EmptyCpsNotice
        disableEmptyCpsNotice={props.disableEmptyCpsNotice}
        emptyCps={props.emptyCps}
      />
      <NoCpsInRangeNotice
        disableNoCpsInRange={props.disableNoCpsInRange}
        noCpsInRange={props.noCpsInRange}
        hasMap={props.hasMap}
      />
      <InHousePharmacyNotice
        disableInHouseNotice={props.disableInHouseNotice}
        hasInHouseCp={props.hasInHouseCp}
        policy_doc_url={props.policy_doc_url}
      />
      <HinNotice disableHinNotice={props.disableHinNotice} hinMissing={props.hinMissing} />
    </>
  );
}
